// @generated by protoc-gen-es v2.15.0 with parameter "target=ts,import_extension=js"
// @generated from file console/admin/v1/org.proto (package console.admin.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Feature, IdpMode, OrgStatus, Policy, Product } from "../../common/v1/common_pb.js";
import { file_console_common_v1_common } from "../../common/v1/common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file console/admin/v1/org.proto.
 */
export const file_console_admin_v1_org: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_console_common_v1_common]);

/**
 * @generated from message console.admin.v1.Org
 */
export type Org = Message<"console.admin.v1.Org"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * `[a-z0-9-]{1,32}`; becomes the `orgid` field of every key.
   *
   * @generated from field: string slug = 2;
   */
  slug: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: console.common.v1.OrgStatus status = 4;
   */
  status: OrgStatus;

  /**
   * @generated from field: console.common.v1.IdpMode idp_mode = 6;
   */
  idpMode: IdpMode;

  /**
   * @generated from field: repeated console.common.v1.Feature features = 7;
   */
  features: Feature[];

  /**
   * @generated from field: repeated console.common.v1.Product products = 8;
   */
  products: Product[];

  /**
   * @generated from field: console.admin.v1.SeatPool seat_pool = 9;
   */
  seatPool?: SeatPool | undefined;

  /**
   * @generated from field: console.common.v1.Policy policy = 10;
   */
  policy?: Policy | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp | undefined;

  /**
   * Devices on record: active and suspended (revoked ones leave the
   * record). A device joins the record when MotionSafe staff assign it to
   * this organization. There is no limit.
   *
   * @generated from field: uint32 devices_on_record = 12;
   */
  devicesOnRecord: number;

  /**
   * The identity provider's id for the organization, once it has one.
   *
   * @generated from field: string idp_org_id = 13;
   */
  idpOrgId: string;
};

/**
 * Describes the message console.admin.v1.Org.
 * Use `create(OrgSchema)` to create a new message.
 */
export const OrgSchema: GenMessage<Org> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 0);

/**
 * @generated from message console.admin.v1.SeatPool
 */
export type SeatPool = Message<"console.admin.v1.SeatPool"> & {
  /**
   * @generated from field: uint32 count = 1;
   */
  count: number;

  /**
   * Active operator accounts. Shown as "used of count".
   *
   * @generated from field: uint32 used = 2;
   */
  used: number;

  /**
   * Accounts waiting for a seat (USER_STATUS_PENDING_SEAT).
   *
   * @generated from field: uint32 pending = 3;
   */
  pending: number;

  /**
   * @generated from field: google.protobuf.Timestamp valid_from = 4;
   */
  validFrom?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp valid_to = 5;
   */
  validTo?: Timestamp | undefined;

  /**
   * True for the MotionSafe organization, which has no pool; `count` is 0.
   *
   * @generated from field: bool unlimited = 6;
   */
  unlimited: boolean;
};

/**
 * Describes the message console.admin.v1.SeatPool.
 * Use `create(SeatPoolSchema)` to create a new message.
 */
export const SeatPoolSchema: GenMessage<SeatPool> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 1);

/**
 * @generated from message console.admin.v1.CreateOrgRequest
 */
export type CreateOrgRequest = Message<"console.admin.v1.CreateOrgRequest"> & {
  /**
   * @generated from field: string slug = 1;
   */
  slug: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint32 seat_count = 4;
   */
  seatCount: number;

  /**
   * @generated from field: repeated console.common.v1.Product products = 5;
   */
  products: Product[];

  /**
   * @generated from field: console.common.v1.Policy policy = 6;
   */
  policy?: Policy | undefined;

  /**
   * An organization that already exists at the identity provider, to link
   * to. Empty creates one there.
   *
   * @generated from field: string idp_org_id = 8;
   */
  idpOrgId: string;
};

/**
 * Describes the message console.admin.v1.CreateOrgRequest.
 * Use `create(CreateOrgRequestSchema)` to create a new message.
 */
export const CreateOrgRequestSchema: GenMessage<CreateOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 2);

/**
 * @generated from message console.admin.v1.CreateOrgResponse
 */
export type CreateOrgResponse = Message<"console.admin.v1.CreateOrgResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;

  /**
   * The generation of the organization's current key: the first key, made
   * with the organization, or the one restored from the vault for a slug
   * that had keys before. Empty when no key could be made.
   *
   * @generated from field: string first_key = 2;
   */
  firstKey: string;

  /**
   * What went wrong making the key. With `first_key` empty, no key was
   * made; with it set, the key stands and something beside it failed.
   * Never key material.
   *
   * @generated from field: string key_refusal = 3;
   */
  keyRefusal: string;

  /**
   * People brought in from the linked identity provider organization, each
   * waiting for a seat.
   *
   * @generated from field: uint32 people_added = 4;
   */
  peopleAdded: number;
};

/**
 * Describes the message console.admin.v1.CreateOrgResponse.
 * Use `create(CreateOrgResponseSchema)` to create a new message.
 */
export const CreateOrgResponseSchema: GenMessage<CreateOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 3);

/**
 * @generated from message console.admin.v1.GetOrgRequest
 */
export type GetOrgRequest = Message<"console.admin.v1.GetOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.GetOrgRequest.
 * Use `create(GetOrgRequestSchema)` to create a new message.
 */
export const GetOrgRequestSchema: GenMessage<GetOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 4);

/**
 * @generated from message console.admin.v1.GetOrgResponse
 */
export type GetOrgResponse = Message<"console.admin.v1.GetOrgResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.GetOrgResponse.
 * Use `create(GetOrgResponseSchema)` to create a new message.
 */
export const GetOrgResponseSchema: GenMessage<GetOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 5);

/**
 * @generated from message console.admin.v1.ListOrgsRequest
 */
export type ListOrgsRequest = Message<"console.admin.v1.ListOrgsRequest"> & {
  /**
   * Staff only; org admins see only their own organization through GetOrg.
   *
   * @generated from field: console.common.v1.OrgStatus status = 1;
   */
  status: OrgStatus;

  /**
   * @generated from field: string query = 2;
   */
  query: string;

  /**
   * These organizations only, at most 100.
   *
   * @generated from field: repeated string ids = 6;
   */
  ids: string[];

  /**
   * @generated from field: uint32 page_size = 3;
   */
  pageSize: number;

  /**
   * @generated from field: string page_token = 4;
   */
  pageToken: string;

  /**
   * Rows to skip, for a numbered page. Used in place of `page_token`.
   *
   * @generated from field: uint32 offset = 5;
   */
  offset: number;
};

/**
 * Describes the message console.admin.v1.ListOrgsRequest.
 * Use `create(ListOrgsRequestSchema)` to create a new message.
 */
export const ListOrgsRequestSchema: GenMessage<ListOrgsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 6);

/**
 * @generated from message console.admin.v1.ListOrgsResponse
 */
export type ListOrgsResponse = Message<"console.admin.v1.ListOrgsResponse"> & {
  /**
   * @generated from field: repeated console.admin.v1.Org orgs = 1;
   */
  orgs: Org[];

  /**
   * @generated from field: string next_page_token = 2;
   */
  nextPageToken: string;

  /**
   * How many organizations match, across every page.
   *
   * @generated from field: uint32 total = 3;
   */
  total: number;
};

/**
 * Describes the message console.admin.v1.ListOrgsResponse.
 * Use `create(ListOrgsResponseSchema)` to create a new message.
 */
export const ListOrgsResponseSchema: GenMessage<ListOrgsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 7);

/**
 * @generated from message console.admin.v1.CountOrgsRequest
 */
export type CountOrgsRequest = Message<"console.admin.v1.CountOrgsRequest"> & {
};

/**
 * Describes the message console.admin.v1.CountOrgsRequest.
 * Use `create(CountOrgsRequestSchema)` to create a new message.
 */
export const CountOrgsRequestSchema: GenMessage<CountOrgsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 8);

/**
 * @generated from message console.admin.v1.CountOrgsResponse
 */
export type CountOrgsResponse = Message<"console.admin.v1.CountOrgsResponse"> & {
  /**
   * Every status that has an organization, once.
   *
   * @generated from field: repeated console.admin.v1.OrgCount groups = 1;
   */
  groups: OrgCount[];
};

/**
 * Describes the message console.admin.v1.CountOrgsResponse.
 * Use `create(CountOrgsResponseSchema)` to create a new message.
 */
export const CountOrgsResponseSchema: GenMessage<CountOrgsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 9);

/**
 * @generated from message console.admin.v1.OrgCount
 */
export type OrgCount = Message<"console.admin.v1.OrgCount"> & {
  /**
   * @generated from field: console.common.v1.OrgStatus status = 1;
   */
  status: OrgStatus;

  /**
   * @generated from field: uint32 orgs = 2;
   */
  orgs: number;
};

/**
 * Describes the message console.admin.v1.OrgCount.
 * Use `create(OrgCountSchema)` to create a new message.
 */
export const OrgCountSchema: GenMessage<OrgCount> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 10);

/**
 * @generated from message console.admin.v1.UpdateOrgRequest
 */
export type UpdateOrgRequest = Message<"console.admin.v1.UpdateOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message console.admin.v1.UpdateOrgRequest.
 * Use `create(UpdateOrgRequestSchema)` to create a new message.
 */
export const UpdateOrgRequestSchema: GenMessage<UpdateOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 11);

/**
 * @generated from message console.admin.v1.UpdateOrgResponse
 */
export type UpdateOrgResponse = Message<"console.admin.v1.UpdateOrgResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.UpdateOrgResponse.
 * Use `create(UpdateOrgResponseSchema)` to create a new message.
 */
export const UpdateOrgResponseSchema: GenMessage<UpdateOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 12);

/**
 * @generated from message console.admin.v1.SetPolicyRequest
 */
export type SetPolicyRequest = Message<"console.admin.v1.SetPolicyRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: console.common.v1.Policy policy = 2;
   */
  policy?: Policy | undefined;
};

/**
 * Describes the message console.admin.v1.SetPolicyRequest.
 * Use `create(SetPolicyRequestSchema)` to create a new message.
 */
export const SetPolicyRequestSchema: GenMessage<SetPolicyRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 13);

/**
 * @generated from message console.admin.v1.SetPolicyResponse
 */
export type SetPolicyResponse = Message<"console.admin.v1.SetPolicyResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.SetPolicyResponse.
 * Use `create(SetPolicyResponseSchema)` to create a new message.
 */
export const SetPolicyResponseSchema: GenMessage<SetPolicyResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 14);

/**
 * @generated from message console.admin.v1.SetSeatPoolRequest
 */
export type SetSeatPoolRequest = Message<"console.admin.v1.SetSeatPoolRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: uint32 count = 2;
   */
  count: number;

  /**
   * @generated from field: google.protobuf.Timestamp valid_to = 3;
   */
  validTo?: Timestamp | undefined;
};

/**
 * Describes the message console.admin.v1.SetSeatPoolRequest.
 * Use `create(SetSeatPoolRequestSchema)` to create a new message.
 */
export const SetSeatPoolRequestSchema: GenMessage<SetSeatPoolRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 15);

/**
 * @generated from message console.admin.v1.SetSeatPoolResponse
 */
export type SetSeatPoolResponse = Message<"console.admin.v1.SetSeatPoolResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.SetSeatPoolResponse.
 * Use `create(SetSeatPoolResponseSchema)` to create a new message.
 */
export const SetSeatPoolResponseSchema: GenMessage<SetSeatPoolResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 16);

/**
 * @generated from message console.admin.v1.SetProductsRequest
 */
export type SetProductsRequest = Message<"console.admin.v1.SetProductsRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: repeated console.common.v1.Product products = 2;
   */
  products: Product[];
};

/**
 * Describes the message console.admin.v1.SetProductsRequest.
 * Use `create(SetProductsRequestSchema)` to create a new message.
 */
export const SetProductsRequestSchema: GenMessage<SetProductsRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 17);

/**
 * @generated from message console.admin.v1.SetProductsResponse
 */
export type SetProductsResponse = Message<"console.admin.v1.SetProductsResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.SetProductsResponse.
 * Use `create(SetProductsResponseSchema)` to create a new message.
 */
export const SetProductsResponseSchema: GenMessage<SetProductsResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 18);

/**
 * @generated from message console.admin.v1.SetFeatureRequest
 */
export type SetFeatureRequest = Message<"console.admin.v1.SetFeatureRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: console.common.v1.Feature feature = 2;
   */
  feature: Feature;

  /**
   * @generated from field: bool enabled = 3;
   */
  enabled: boolean;

  /**
   * Recorded in the audit event (contract reference, reason for removal).
   *
   * @generated from field: string note = 4;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.SetFeatureRequest.
 * Use `create(SetFeatureRequestSchema)` to create a new message.
 */
export const SetFeatureRequestSchema: GenMessage<SetFeatureRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 19);

/**
 * @generated from message console.admin.v1.SetFeatureResponse
 */
export type SetFeatureResponse = Message<"console.admin.v1.SetFeatureResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;

  /**
   * People brought in from the directory when directory sync was switched on.
   *
   * @generated from field: uint32 people_added = 2;
   */
  peopleAdded: number;
};

/**
 * Describes the message console.admin.v1.SetFeatureResponse.
 * Use `create(SetFeatureResponseSchema)` to create a new message.
 */
export const SetFeatureResponseSchema: GenMessage<SetFeatureResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 20);

/**
 * @generated from message console.admin.v1.ActivateOrgRequest
 */
export type ActivateOrgRequest = Message<"console.admin.v1.ActivateOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: uint32 seat_count = 2;
   */
  seatCount: number;

  /**
   * @generated from field: repeated console.common.v1.Product products = 3;
   */
  products: Product[];
};

/**
 * Describes the message console.admin.v1.ActivateOrgRequest.
 * Use `create(ActivateOrgRequestSchema)` to create a new message.
 */
export const ActivateOrgRequestSchema: GenMessage<ActivateOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 21);

/**
 * @generated from message console.admin.v1.ActivateOrgResponse
 */
export type ActivateOrgResponse = Message<"console.admin.v1.ActivateOrgResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.ActivateOrgResponse.
 * Use `create(ActivateOrgResponseSchema)` to create a new message.
 */
export const ActivateOrgResponseSchema: GenMessage<ActivateOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 22);

/**
 * @generated from message console.admin.v1.SuspendOrgRequest
 */
export type SuspendOrgRequest = Message<"console.admin.v1.SuspendOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.SuspendOrgRequest.
 * Use `create(SuspendOrgRequestSchema)` to create a new message.
 */
export const SuspendOrgRequestSchema: GenMessage<SuspendOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 23);

/**
 * @generated from message console.admin.v1.SuspendOrgResponse
 */
export type SuspendOrgResponse = Message<"console.admin.v1.SuspendOrgResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.SuspendOrgResponse.
 * Use `create(SuspendOrgResponseSchema)` to create a new message.
 */
export const SuspendOrgResponseSchema: GenMessage<SuspendOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 24);

/**
 * @generated from message console.admin.v1.LinkIdpOrganizationRequest
 */
export type LinkIdpOrganizationRequest = Message<"console.admin.v1.LinkIdpOrganizationRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string idp_org_id = 2;
   */
  idpOrgId: string;
};

/**
 * Describes the message console.admin.v1.LinkIdpOrganizationRequest.
 * Use `create(LinkIdpOrganizationRequestSchema)` to create a new message.
 */
export const LinkIdpOrganizationRequestSchema: GenMessage<LinkIdpOrganizationRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 25);

/**
 * @generated from message console.admin.v1.LinkIdpOrganizationResponse
 */
export type LinkIdpOrganizationResponse = Message<"console.admin.v1.LinkIdpOrganizationResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;

  /**
   * The organization's name at the identity provider, for the person to
   * check they linked the one they meant.
   *
   * @generated from field: string idp_name = 2;
   */
  idpName: string;

  /**
   * The provider organization this one was linked to before, when there
   * was one. It is left as it was, for a person to delete there.
   *
   * @generated from field: string previous_idp_org_id = 3;
   */
  previousIdpOrgId: string;

  /**
   * People the identity provider's organization has who were not on record
   * here: brought in, each waiting for a seat.
   *
   * @generated from field: uint32 people_added = 4;
   */
  peopleAdded: number;

  /**
   * People on record here who are not in the identity provider's
   * organization: taken out.
   *
   * @generated from field: uint32 people_removed = 5;
   */
  peopleRemoved: number;

  /**
   * People who looked gone and were left in place, because too many did at
   * once; staff are notified.
   *
   * @generated from field: uint32 people_held = 6;
   */
  peopleHeld: number;
};

/**
 * Describes the message console.admin.v1.LinkIdpOrganizationResponse.
 * Use `create(LinkIdpOrganizationResponseSchema)` to create a new message.
 */
export const LinkIdpOrganizationResponseSchema: GenMessage<LinkIdpOrganizationResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 26);

/**
 * @generated from message console.admin.v1.CloseOrgRequest
 */
export type CloseOrgRequest = Message<"console.admin.v1.CloseOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: string note = 2;
   */
  note: string;
};

/**
 * Describes the message console.admin.v1.CloseOrgRequest.
 * Use `create(CloseOrgRequestSchema)` to create a new message.
 */
export const CloseOrgRequestSchema: GenMessage<CloseOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 27);

/**
 * @generated from message console.admin.v1.CloseOrgResponse
 */
export type CloseOrgResponse = Message<"console.admin.v1.CloseOrgResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.CloseOrgResponse.
 * Use `create(CloseOrgResponseSchema)` to create a new message.
 */
export const CloseOrgResponseSchema: GenMessage<CloseOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 28);

/**
 * @generated from message console.admin.v1.DeleteOrgRequest
 */
export type DeleteOrgRequest = Message<"console.admin.v1.DeleteOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * The organization's slug, typed by the person deleting it. The call is
   * refused unless it matches.
   *
   * @generated from field: string confirm_slug = 2;
   */
  confirmSlug: string;
};

/**
 * Describes the message console.admin.v1.DeleteOrgRequest.
 * Use `create(DeleteOrgRequestSchema)` to create a new message.
 */
export const DeleteOrgRequestSchema: GenMessage<DeleteOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 29);

/**
 * @generated from message console.admin.v1.UnlinkOrgRequest
 */
export type UnlinkOrgRequest = Message<"console.admin.v1.UnlinkOrgRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * The organization's slug, typed by the person unlinking it.
   *
   * @generated from field: string confirm_slug = 2;
   */
  confirmSlug: string;
};

/**
 * Describes the message console.admin.v1.UnlinkOrgRequest.
 * Use `create(UnlinkOrgRequestSchema)` to create a new message.
 */
export const UnlinkOrgRequestSchema: GenMessage<UnlinkOrgRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 30);

/**
 * @generated from message console.admin.v1.UnlinkOrgResponse
 */
export type UnlinkOrgResponse = Message<"console.admin.v1.UnlinkOrgResponse"> & {
  /**
   * What it was linked to at the identity provider, left as it was.
   *
   * @generated from field: string idp_org_id = 1;
   */
  idpOrgId: string;
};

/**
 * Describes the message console.admin.v1.UnlinkOrgResponse.
 * Use `create(UnlinkOrgResponseSchema)` to create a new message.
 */
export const UnlinkOrgResponseSchema: GenMessage<UnlinkOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 31);

/**
 * @generated from message console.admin.v1.DeleteOrgResponse
 */
export type DeleteOrgResponse = Message<"console.admin.v1.DeleteOrgResponse"> & {
  /**
   * Always empty: a refusal outside the console stops the delete, and the
   * call fails naming it.
   *
   * @generated from field: repeated string leftovers = 1;
   */
  leftovers: string[];
};

/**
 * Describes the message console.admin.v1.DeleteOrgResponse.
 * Use `create(DeleteOrgResponseSchema)` to create a new message.
 */
export const DeleteOrgResponseSchema: GenMessage<DeleteOrgResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 32);

/**
 * @generated from message console.admin.v1.CreateIdpSetupLinkRequest
 */
export type CreateIdpSetupLinkRequest = Message<"console.admin.v1.CreateIdpSetupLinkRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: console.admin.v1.IdpSetup setup = 2;
   */
  setup: IdpSetup;
};

/**
 * Describes the message console.admin.v1.CreateIdpSetupLinkRequest.
 * Use `create(CreateIdpSetupLinkRequestSchema)` to create a new message.
 */
export const CreateIdpSetupLinkRequestSchema: GenMessage<CreateIdpSetupLinkRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 33);

/**
 * @generated from message console.admin.v1.CreateIdpSetupLinkResponse
 */
export type CreateIdpSetupLinkResponse = Message<"console.admin.v1.CreateIdpSetupLinkResponse"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message console.admin.v1.CreateIdpSetupLinkResponse.
 * Use `create(CreateIdpSetupLinkResponseSchema)` to create a new message.
 */
export const CreateIdpSetupLinkResponseSchema: GenMessage<CreateIdpSetupLinkResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 34);

/**
 * @generated from message console.admin.v1.SetSsoSignInRequest
 */
export type SetSsoSignInRequest = Message<"console.admin.v1.SetSsoSignInRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;

  /**
   * @generated from field: bool enabled = 2;
   */
  enabled: boolean;
};

/**
 * Describes the message console.admin.v1.SetSsoSignInRequest.
 * Use `create(SetSsoSignInRequestSchema)` to create a new message.
 */
export const SetSsoSignInRequestSchema: GenMessage<SetSsoSignInRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 35);

/**
 * @generated from message console.admin.v1.SetSsoSignInResponse
 */
export type SetSsoSignInResponse = Message<"console.admin.v1.SetSsoSignInResponse"> & {
  /**
   * @generated from field: console.admin.v1.Org org = 1;
   */
  org?: Org | undefined;
};

/**
 * Describes the message console.admin.v1.SetSsoSignInResponse.
 * Use `create(SetSsoSignInResponseSchema)` to create a new message.
 */
export const SetSsoSignInResponseSchema: GenMessage<SetSsoSignInResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 36);

/**
 * @generated from message console.admin.v1.GetIdpStatusRequest
 */
export type GetIdpStatusRequest = Message<"console.admin.v1.GetIdpStatusRequest"> & {
  /**
   * @generated from field: string org_id = 1;
   */
  orgId: string;
};

/**
 * Describes the message console.admin.v1.GetIdpStatusRequest.
 * Use `create(GetIdpStatusRequestSchema)` to create a new message.
 */
export const GetIdpStatusRequestSchema: GenMessage<GetIdpStatusRequest> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 37);

/**
 * @generated from message console.admin.v1.GetIdpStatusResponse
 */
export type GetIdpStatusResponse = Message<"console.admin.v1.GetIdpStatusResponse"> & {
  /**
   * @generated from field: console.admin.v1.ConnectionState sso_connection = 1;
   */
  ssoConnection: ConnectionState;

  /**
   * @generated from field: console.admin.v1.ConnectionState directory = 2;
   */
  directory: ConnectionState;

  /**
   * Whether a setup link for each has ever been sent for this organization:
   * Support sends one again only once one has (CreateIdpSetupLink).
   *
   * @generated from field: bool sso_link_sent = 3;
   */
  ssoLinkSent: boolean;

  /**
   * @generated from field: bool directory_link_sent = 4;
   */
  directoryLinkSent: boolean;
};

/**
 * Describes the message console.admin.v1.GetIdpStatusResponse.
 * Use `create(GetIdpStatusResponseSchema)` to create a new message.
 */
export const GetIdpStatusResponseSchema: GenMessage<GetIdpStatusResponse> = /*@__PURE__*/
  messageDesc(file_console_admin_v1_org, 38);

/**
 * @generated from enum console.admin.v1.IdpSetup
 */
export enum IdpSetup {
  /**
   * @generated from enum value: IDP_SETUP_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: IDP_SETUP_SSO = 1;
   */
  SSO = 1,

  /**
   * @generated from enum value: IDP_SETUP_DIRECTORY = 2;
   */
  DIRECTORY = 2,
}

/**
 * Describes the enum console.admin.v1.IdpSetup.
 */
export const IdpSetupSchema: GenEnum<IdpSetup> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_org, 0);

/**
 * @generated from enum console.admin.v1.ConnectionState
 */
export enum ConnectionState {
  /**
   * @generated from enum value: CONNECTION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Connected and able to sign people in (or, for a directory, to be read).
   *
   * @generated from enum value: CONNECTION_STATE_CONNECTED = 1;
   */
  CONNECTED = 1,

  /**
   * Nothing connected yet, or a connection that is not active.
   *
   * @generated from enum value: CONNECTION_STATE_NOT_CONNECTED = 2;
   */
  NOT_CONNECTED = 2,

  /**
   * The identity provider could not be asked.
   *
   * @generated from enum value: CONNECTION_STATE_UNKNOWN = 3;
   */
  UNKNOWN = 3,
}

/**
 * Describes the enum console.admin.v1.ConnectionState.
 */
export const ConnectionStateSchema: GenEnum<ConnectionState> = /*@__PURE__*/
  enumDesc(file_console_admin_v1_org, 1);

/**
 * Organizations: lifecycle, policy, products, seat pool, add-ons, sharing overrides.
 *
 * Authorization is by principal: an org admin may read and set policy on their
 * own organization; everything that changes what an organization has paid for
 * (seat pool, products, features, activation, closure) is MotionSafe staff
 * only. An add-on staff have given is the organization's to set up. Every RPC here writes an audit event under the caller's identity.
 *
 * @generated from service console.admin.v1.OrgService
 */
export const OrgService: GenService<{
  /**
   * @generated from rpc console.admin.v1.OrgService.CreateOrg
   */
  createOrg: {
    methodKind: "unary";
    input: typeof CreateOrgRequestSchema;
    output: typeof CreateOrgResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.GetOrg
   */
  getOrg: {
    methodKind: "unary";
    input: typeof GetOrgRequestSchema;
    output: typeof GetOrgResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.ListOrgs
   */
  listOrgs: {
    methodKind: "unary";
    input: typeof ListOrgsRequestSchema;
    output: typeof ListOrgsResponseSchema;
  },
  /**
   * Staff only. How many organizations there are in each status.
   *
   * @generated from rpc console.admin.v1.OrgService.CountOrgs
   */
  countOrgs: {
    methodKind: "unary";
    input: typeof CountOrgsRequestSchema;
    output: typeof CountOrgsResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.UpdateOrg
   */
  updateOrg: {
    methodKind: "unary";
    input: typeof UpdateOrgRequestSchema;
    output: typeof UpdateOrgResponseSchema;
  },
  /**
   * Org admin. Fields reserved to staff (mfa_locked) are ignored unless the
   * caller is staff.
   *
   * @generated from rpc console.admin.v1.OrgService.SetPolicy
   */
  setPolicy: {
    methodKind: "unary";
    input: typeof SetPolicyRequestSchema;
    output: typeof SetPolicyResponseSchema;
  },
  /**
   * Staff only.
   *
   * @generated from rpc console.admin.v1.OrgService.SetSeatPool
   */
  setSeatPool: {
    methodKind: "unary";
    input: typeof SetSeatPoolRequestSchema;
    output: typeof SetSeatPoolResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.SetProducts
   */
  setProducts: {
    methodKind: "unary";
    input: typeof SetProductsRequestSchema;
    output: typeof SetProductsResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.SetFeature
   */
  setFeature: {
    methodKind: "unary";
    input: typeof SetFeatureRequestSchema;
    output: typeof SetFeatureResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.ActivateOrg
   */
  activateOrg: {
    methodKind: "unary";
    input: typeof ActivateOrgRequestSchema;
    output: typeof ActivateOrgResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.SuspendOrg
   */
  suspendOrg: {
    methodKind: "unary";
    input: typeof SuspendOrgRequestSchema;
    output: typeof SuspendOrgResponseSchema;
  },
  /**
   * MotionSafe admins only. Points the organization at one that already
   * exists at the identity provider, by the provider's id for it: a
   * customer whose single sign-on was set up there first, or the
   * provider's own test organization.
   *
   * @generated from rpc console.admin.v1.OrgService.LinkIdpOrganization
   */
  linkIdpOrganization: {
    methodKind: "unary";
    input: typeof LinkIdpOrganizationRequestSchema;
    output: typeof LinkIdpOrganizationResponseSchema;
  },
  /**
   * @generated from rpc console.admin.v1.OrgService.CloseOrg
   */
  closeOrg: {
    methodKind: "unary";
    input: typeof CloseOrgRequestSchema;
    output: typeof CloseOrgResponseSchema;
  },
  /**
   * MotionSafe admins only. The organization and everything recorded under
   * it, gone: people, sessions, keys (from the vault as well),
   * notifications and its audit trail, and its organization and accounts at
   * the identity provider. Its devices are taken out of circulation, so each
   * clears what it holds at its next contact. Not reversible. The identity
   * provider is cleaned up first; if it refuses, nothing else is deleted.
   *
   * @generated from rpc console.admin.v1.OrgService.DeleteOrg
   */
  deleteOrg: {
    methodKind: "unary";
    input: typeof DeleteOrgRequestSchema;
    output: typeof DeleteOrgResponseSchema;
  },
  /**
   * MotionSafe admins only. Removes the organization from the console and
   * touches nothing else: its organization and accounts at the identity
   * provider stay as they are, and so do its keys in the vault. Its console
   * record, sessions and audit trail go, and its devices are taken out of
   * circulation. For an organization linked to one the console does not own.
   *
   * @generated from rpc console.admin.v1.OrgService.UnlinkOrg
   */
  unlinkOrg: {
    methodKind: "unary";
    input: typeof UnlinkOrgRequestSchema;
    output: typeof UnlinkOrgResponseSchema;
  },
  /**
   * Org admin, for an organization that has the add-on: a short-lived link
   * to the identity provider's own setup pages, where the organization
   * connects its single sign-on or its directory. The link is a way in to
   * those pages, so it is returned once and recorded nowhere. Among
   * MotionSafe staff, Accounts or an admin sends the first; Support sends
   * one again only once one has been sent.
   *
   * @generated from rpc console.admin.v1.OrgService.CreateIdpSetupLink
   */
  createIdpSetupLink: {
    methodKind: "unary";
    input: typeof CreateIdpSetupLinkRequestSchema;
    output: typeof CreateIdpSetupLinkResponseSchema;
  },
  /**
   * Org admin, for an organization that has the single sign-on add-on:
   * whether its people sign in through its own identity provider or with
   * passwords. Turned on only while its connection there is active.
   *
   * @generated from rpc console.admin.v1.OrgService.SetSsoSignIn
   */
  setSsoSignIn: {
    methodKind: "unary";
    input: typeof SetSsoSignInRequestSchema;
    output: typeof SetSsoSignInResponseSchema;
  },
  /**
   * Org admin. What the identity provider has for the organization right
   * now: whether its single sign-on connection and its directory are
   * connected. Asked of the provider each time; nothing is stored.
   *
   * @generated from rpc console.admin.v1.OrgService.GetIdpStatus
   */
  getIdpStatus: {
    methodKind: "unary";
    input: typeof GetIdpStatusRequestSchema;
    output: typeof GetIdpStatusResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_console_admin_v1_org, 0);

